import React from 'react';
import { useLocation } from 'react-router-dom';

import { BASE_PATH, LOGIN_TITLE, authMethods } from '../../constants';
import envConfig from '../../constants/env';
import InAppLogin from './InAppLogin';
import ShibbolethLogin from './ShibbolethLogin';
import useTitle from '../../hooks/useTitle';
import MultiSamlLogin from './MultiSamlLogin';

const Login = () => {
  useTitle(LOGIN_TITLE);
  const location = useLocation();
  const referrer = location.state?.referrer || `${BASE_PATH}/`;
  const auth = envConfig.LOGIN_METHOD;

  switch (auth) {
    case authMethods.SHIBBOLETH:
      return <ShibbolethLogin {...{ referrer }} />;
    case authMethods.IN_APP:
      return <InAppLogin {...{ referrer }} />;
    case authMethods.MULTI_SAML:
      return <MultiSamlLogin {...{ referrer }} />;
    default:
      break;
  }

  return null;
};

export { Login as UnwrappedLogin };

export default Login;
